import { createApi } from "@reduxjs/toolkit/query/react";
import baseQuery from "../baseQuery";
import {
  ADD_ADDRESS,
  CONTACT_US,
  DELETE_ADDRESS,
  DELETE_PRESCRIPTION,
  ENQUIRTY_CREATE,
  ENQUIRY_DELETE_PROFILE,
  GET_ADDRESS_LIST,
  GET_PATIENT_DETAILS,
  GET_PRESCRIPTION,
  GET_STATE_AND_CITY_PINCODE,
  MAKE_ADDRESS_DEFAULT,
  MY_MEDICINE,
  REGENERATE_EMAIL_LINK,
  SUBSCRIBE,
  UPDATE_ADDRESS,
  UPDATE_USER,
  UPLOAD_PRESCRIPTION,
  VALIDATE_EMAIL_USER,
} from "../routes";

export const myAccountApi = createApi({
  reducerPath: "myAccountApi",
  baseQuery: baseQuery,
  endpoints: (builder) => ({
    getStateCityByPinCode: builder.mutation<any, { pincode: string }>({
      query: (credential) => ({
        url: GET_STATE_AND_CITY_PINCODE,
        method: "POST",
        body: credential,
      }),
    }),
    getProfile: builder.query({
      query: (id: number) => ({
        url: GET_PATIENT_DETAILS,
        params: { id },
      }),
      transformResponse: (response: ApiResponse<PatientProfile>) => {
        return response?.patient;
      },
    }),
    updateProfile: builder.mutation<ApiResponse<PatientProfile>, {}>({
      query: (credential) => ({
        url: UPDATE_USER,
        method: "POST",
        body: credential,
        formData: true,
      }),
    }),
    getAddress: builder.mutation<AddressResponse, {}>({
      query: (credential) => ({
        url: GET_ADDRESS_LIST,
        method: "POST",
        body: credential,
      }),
    }),
    addAddress: builder.mutation<ApiResponse<any>, {}>({
      query: (credential) => ({
        url: ADD_ADDRESS,
        method: "POST",
        body: credential,
      }),
    }),
    updateAddress: builder.mutation<ApiResponse<any>, {}>({
      query: (credential) => ({
        url: UPDATE_ADDRESS,
        method: "POST",
        body: credential,
      }),
    }),
    makeDefaultAddress: builder.mutation<ApiResponse<any>, {}>({
      query: (credential) => ({
        url: MAKE_ADDRESS_DEFAULT,
        method: "POST",
        body: credential,
      }),
    }),
    deleteAddress: builder.mutation<ApiResponse<any>, {}>({
      query: (credential) => ({
        url: DELETE_ADDRESS,
        method: "POST",
        body: credential,
      }),
    }),
    getPrescription: builder.query({
      query: (id: number) => ({
        url: GET_PRESCRIPTION,
        params: { id },
      }),
      transformResponse: (response: ApiResponse<PrescriptionTypes[]>) => {
        return response?.prescription;
      },
    }),
    addPrescription: builder.mutation<ApiResponse<any>, FormData>({
      query: (credential) => ({
        url: UPLOAD_PRESCRIPTION,
        method: "POST",
        body: credential,
      }),
    }),
    removePrescription: builder.mutation<ApiResponse<any>, {}>({
      query: (id) => ({
        url: DELETE_PRESCRIPTION,
        method: "POST",
        params: { id },
      }),
    }),
    enquirtyCreatePrescription: builder.mutation<ApiResponse<any>, {}>({
      query: (credential) => ({
        url: ENQUIRTY_CREATE,
        method: "POST",
        body: credential,
      }),
    }),
    myMedicine: builder.query({
      query: (customer_id) => ({
        url: MY_MEDICINE,
        params: {customer_id},
      }),
      transformResponse: (response: ApiResponse<MedicineTypes[]>) => {
        return response?.data;
      },
    }),
    enquireDeleteProfile: builder.mutation<ApiResponse<any>, {}>({
      query: (credential) => ({
        url: ENQUIRY_DELETE_PROFILE,
        method: "POST",
        body: credential,
      }),
    }),
    contactus: builder.mutation<ApiResponse<any>, {}>({
      query: (credential) => ({
        url: CONTACT_US,
        method: "POST",
        body: credential,
      }),
    }),
    subscribe: builder.mutation<ApiResponse<any>, {}>({
      query: (credential) => ({
        url: SUBSCRIBE,
        method: "POST",
        body: credential,
      }),
    }),
    regenerateEmailLink: builder.mutation<ApiResponse<any>, {}>({
      query: (credential) => ({
        url: REGENERATE_EMAIL_LINK,
        method: "POST",
        body: credential,
      }),
    }),
    validateEmailUser: builder.query({
      query: (data) => ({
        url: `${VALIDATE_EMAIL_USER}/${data?.patient_id}/${data?.token}`
      }),
      transformResponse: (response: ApiResponse<any>) => {
        return response;
      },
    }),
  }),
});

export const {
  useGetStateCityByPinCodeMutation,
  useLazyGetProfileQuery,
  useUpdateProfileMutation,
  useGetAddressMutation,
  useDeleteAddressMutation,
  useGetPrescriptionQuery,
  useAddPrescriptionMutation,
  useRemovePrescriptionMutation,
  useAddAddressMutation,
  useUpdateAddressMutation,
  useMakeDefaultAddressMutation,
  useEnquirtyCreatePrescriptionMutation,
  useMyMedicineQuery,
  useEnquireDeleteProfileMutation,
  useSubscribeMutation,
  useContactusMutation,
  useRegenerateEmailLinkMutation,
  useValidateEmailUserQuery
} = myAccountApi;
